import { type LucideProps } from 'lucide-react'

/**
 * Hierarchy Level 4 Icon
 *
 * Four chevrons arranged in a dice-face pattern (corners).
 * Represents the fourth organizational level (Team).
 *
 * Pattern: Like the 4 on a die
 *   ^   ^
 *
 *   ^   ^
 */
export function HierarchyLevel4({
  size = 24,
  className = '',
  ...props
}: LucideProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      className={className}
      {...props}
    >
      {/* Top-left chevron */}
      <path
        d="M4.5 8.5 L7 5.5 L9.5 8.5"
        strokeWidth="2"
        stroke="currentColor"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Top-right chevron */}
      <path
        d="M14.5 8.5 L17 5.5 L19.5 8.5"
        strokeWidth="2"
        stroke="currentColor"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Bottom-left chevron */}
      <path
        d="M4.5 18.5 L7 15.5 L9.5 18.5"
        strokeWidth="2"
        stroke="currentColor"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Bottom-right chevron */}
      <path
        d="M14.5 18.5 L17 15.5 L19.5 18.5"
        strokeWidth="2"
        stroke="currentColor"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
